<template>
    <div class="container">
        <!-- 轮播图组件 -->
        <carousel :autoplay="true" :autoplay-speed="1000" :loop="true" :pagination-enabled="false" height="300px"
            :per-page="1">
            <slide v-for="(image, index) in images" :key="index">
                <img :src="require('@/assets/images/' + image.filename)" :alt="image.alt"
                    class="img-fluid desktop-image" :style="{ maxHeight: image.maxHeight }">
            </slide>
        </carousel>

        <div class="row">
            <div class="col-md-6">
                <h3>品牌资讯BRAND INFORMATION</h3>
                <ul>
                    <li>东方文化入心，被ΛKF这次国潮联名圈粉了！</li>
                    <li>美无定式，ΛKF荣获美妆行业大奖！</li>
                    <li>嗨，这里是ΛKF美妆频道</li>
                    <li>拯救秋冬妆面，ΛKF散粉精致底妆好伴侣</li>
                    <li>ΛKF带你提升“眼”技，缔造出彩双眸</li>
                    <li>ΛKF泥膜，让肌肤和“初老”说拜拜</li>
                    <li>ΛKF，双十一重磅护肤好物来袭</li>
                    <li>金秋十月，ΛKF与“礼”欢度国庆</li>
                    <li>ΛKF品牌打假升级，制假窝点被查封</li>
                    <li>ΛKF源于生活中的色彩</li>
                </ul>
            </div>
            <div class="col-md-6">
                <img src="../../assets/images/logo.png" alt="ΛKF品牌图片" class="img-fluid">
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'BrandInfo', // 组件名称
    components: {
        Carousel,
        Slide
    },
    data() {
        return {
            images: [
                {
                    filename: '1.jpg',
                    alt: 'Image 1',
                    description: '轻盈似雪 自然定格',
                    maxHeight: '800px' // 移动端图片的最大高度
                },
                {
                    filename: '2.jpg',
                    alt: 'Image 2',
                    description: '创新雾化科技 打破定妆难题',
                    maxHeight: '800px' // 移动端图片的最大高度
                },
                {
                    filename: '3.jpg',
                    alt: 'Image 3',
                    description: '精致眼妆 悦动笔上',
                    maxHeight: '800px' // 移动端图片的最大高度
                },
                {
                    filename: '4.jpg',
                    alt: 'Image 4',
                    description: '持久卷翘 细睫出众',   
                    maxHeight: '800px' // 移动端图片的最大高度
                },
                // {
                //     filename: '5.jpg',
                //     alt: 'Image 5',
                //     description: '一抹绵润，至臻“手”护',
                //     maxHeight: '800px' // 移动端图片的最大高度
                // }
            ],
        }
    }
}
</script>

<style scoped>
/* 样式 */
.desktop-image {
    width: 1000px;
    /* 设置图片宽度为屏幕宽度的80% */
}
</style>